export abstract class Aggregator<T> {
  constructor() {}

  add(stat: T): void {
    this._add(stat);
  }

  abstract getAggregated(): unknown;

  abstract reset(): void;

  protected abstract _add(stat: T): void;
}
